import { useSelector } from "react-redux";
import { getCategoryId } from "../../../../../../state/modules/category";
import { getStoreCode } from "../../../../../../state/modules/config/selectors";
import commonConfig from "../../../../../../config/common";

import visualLinksConfig from "./visualLinksConfig";

const useVisualCategoryHeaderLinks = () => {
  const { visualCategoryHeaderLinkStores } = commonConfig;
  const storeCode = useSelector(getStoreCode);

  return (
    visualCategoryHeaderLinkStores.includes(storeCode) &&
    !!visualLinksConfig[useSelector(getCategoryId)]
  );
};

export default useVisualCategoryHeaderLinks;
